<template>
  <div class="homeHeader">
    <div class="middle">
      <div class="HomeContainer" style="display: flex; align-items: center; padding-top: 10px">
        <el-image alt="中锻材 chinaduancai 中国锻材网" :src="GetResourceUrl('logo_long.jpg')"
          style="width: 240px; height: 64px; cursor: pointer" @click="$router.push('/home')"></el-image>
        <div style="
            flex-grow: 1;
            display: flex;
            margin-left: 54px;
            margin-right: 34px;
          ">
          <el-autocomplete class="filterInput" v-model="filterText" :fetch-suggestions="querySearch"
            :placeholder="l('输入名称、材料等关键词进行搜索')" clearable @clear="handleSearch" @select="handleSelect"
            @keyup.enter.native="handleSearch">
            <el-select v-model="searchPath" slot="prepend" :placeholder="l('请选择')" style="width: 6.5rem"
              @change="changeSearchPath">
              <el-option v-for="item of searchPathList" :key="item.path" :label="item.name"
                :value="item.path"></el-option>
            </el-select>
            <el-button slot="append" class="searchBtn" @click="handleSearch">{{
              l("搜索")
            }}</el-button>
            <template slot-scope="{ item }">
              {{ item.value }}
            </template>
          </el-autocomplete>
          <el-button icon="el-icon-edit" class="publishBtn" @click="handleShowPublishDialog">{{ l("我要发布") }}</el-button>
        </div>

        <div class="downloadContainer">
          <el-image src="https://oss.chinaduancai.com/public_account.jpg"></el-image>
          <div style="position: relative; top: -3px">{{l("中锻材手机版")}}</div>
        </div>
      </div>
    </div>
    <div class="nav">
      <div class="HomeContainer" :class="{i18n:$store.state.lang!='zh-CN'}" style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: relative;
        ">
        <div v-show="$route.name == 'index'" class="categoryTitle">
          <img :src="GetResourceUrl('index/category.svg')" />
          {{ l("产品分类") }}
        </div>
        <div v-show="$route.path.indexOf('/home/index') == -1" class="navItem" style="margin-left: 30px"
          :class="{ active: $route.path.indexOf('/home/index') > -1 }" @click="navTo('/home/index')">
          {{ l("首页") }}
        </div>
        <div class="navItem" :class="{
          active: $route.path.indexOf('/home/quotation') > -1,
        }" @click="navTo('/home/quotation')" @mouseenter="enterNav($event, 1)" @mouseleave="leaveNav">
          {{ l("现货卖场") }}<i class="el-icon-arrow-down"></i>
        </div>

        <div class="navItem" :class="{
          active: $route.path.indexOf('/home/purchase_forging') > -1,
        }" @click="navTo('/home/purchase_forging')" @mouseenter="enterNav($event, 2)" @mouseleave="leaveNav">
          {{ l("锻件定制") }}<i class="el-icon-arrow-down"></i>
        </div>

        <div class="navItem" :class="{
          active: $route.path.indexOf('/home/purchase_material') > -1,
        }" @click="navTo('/home/purchase_material')">
          {{ l("原料求购") }}
        </div>


        <div class="navItem" :class="{
          active: $route.path.indexOf('/home/purchase_machining') > -1,
        }" @click="navTo('/home/purchase_machining')">
          {{ l("机加工") }}
        </div>


        <div class="navItem" :class="{
          active: $route.path.indexOf('/home/inspect_business') > -1,
        }" @click="navTo('/home/inspect_business')">
          {{ l("热处理") }}
        </div>

        <div class="navItem" :class="{
          active: $route.path.indexOf('/home/raise') > -1,
        }" @click="navTo('/home/raise')">
          {{ l("钢厂拼单") }}
        </div>

        <!-- <div class="navItem" :class="{
          active: $route.path.indexOf('/home/purchase_piece') > -1,
        }" @click="navTo('/home/purchase_piece')">
          {{ l("零切交易") }}
        </div> -->



        <div class="navItem" :class="{
          active: $route.path.indexOf('/home/good_business') > -1,
        }" @click="navTo('/home/good_business')" @mouseenter="enterNav($event, 3)" @mouseleave="leaveNav">
          {{ l("优选好商") }}<i class="el-icon-arrow-down"></i>
        </div>



        <div class="navItem" style="margin-right: 30px" :class="{
          active: $route.path.indexOf('/home/forum') > -1,
        }" @click="navTo('/home/forum')" @mouseenter="enterNav($event, 4)" @mouseleave="leaveNav">
          <img :src="GetResourceUrl('header/icon-surrounding.svg')" style="vertical-align: middle" />

          {{ l("周边论坛") }}<i class="el-icon-arrow-down el-icon--right"></i>
        </div>
      </div>
    </div>

    <div v-if="rect" class="subNavContainer" :class="{i18n:$store.state.lang!='zh-CN'}" @mouseenter="inSub = true" @mouseleave="leaveSub">
      <i class="arrow-white" :style="{ left: rect.left + rect.width / 2 - 5 + 'px' }"></i>
      <div class="subNavItem" :class="{ right_side: rect.index == 3 || rect.index == 4 }"
        :style="{ marginLeft: rect.left + 'px' }">
        <template v-if="rect.index == 1">
          <div @click.stop="navTo('/home/quotation?character=1')">
            {{ l("正品现货") }}
          </div>
          <div @click.stop="navTo('/home/quotation?character=2')">
            {{ l("二级余料") }}
          </div>
          <div @click.stop="navTo('/home/quotation?character=3')">
            {{ l("正品余料") }}
          </div>
        </template>
        <template v-else-if="rect.index == 2">
          <div v-for="item of $store.state.basicInfo.forge_typeList" :key="item.id"
            @click.stop="navTo('/home/purchase_forging?forge_type=' + item.id)">
            {{ l(item.name) }}
          </div>
        </template>

        <template v-else-if="rect.index == 3">
          <div v-for="tag of $store.state.basicInfo.tagList.good_business.slice(
            0,
            99
          )" :key="tag.id" @click.stop="navTo('/home/good_business?tag_id=' + tag.id)">
            {{ l(tag.name) }}
          </div>
        </template>

        <template v-else-if="rect.index == 4">
          <div v-for="tag of $store.state.basicInfo.tagList.forum" :key="tag.id"
            @click.stop="navTo('/home/forum?tag_id=' + tag.id)">
            {{ l(tag.name) }}
          </div>
        </template>
      </div>
    </div>

    <el-dialog :title="l('我要发布')" :visible.sync="showPublishDialog" width="900px" class="large-padding-dialog">
      <div class="publishDialog">
        <div class="lineContainer">
          <div class="title">{{ l("我要求购") }}：</div>
          <div class="buttonList">
            <div>
              <div class="buttonItem" @click="
                $router.push({
                  name: 'buyer_purchase_material',
                  params: { command: 'create' },
                })
                ">
                {{ l("原料") }}
              </div>
            </div>
            <div>
              <div class="buttonItem" @click="
                $router.push({
                  name: 'buyer_purchase_forging',
                  params: { command: 'create' },
                })
                ">
                {{ l("锻件") }}
              </div>
              <div class="tip">{{ l("发布图纸定制锻件") }}</div>
            </div>

            <!-- <div>
              <div class="buttonItem" @click="
                $router.push({
                  name: 'buyer_purchase_piece',
                  params: { command: 'create' },
                })
                ">
                {{ l("零切") }}
              </div>
            </div> -->


            <div>
              <div class="buttonItem" @click="
                $router.push({
                  name: 'buyer_purchase_machining',
                  params: { command: 'create' },
                })
                ">
                {{ l("机加工") }}
              </div>
              <div class="tip">{{ l("发布图纸按要求加工") }}</div>
            </div>
          </div>
        </div>

        <div class="lineContainer">
          <div class="title">{{ l("我要出售") }}：</div>
          <div class="buttonList">
            <div>
              <div class="buttonItem" @click="
                $router.push({
                  name: 'seller_quotation',
                  params: { command: 'create' },
                })
                ">
                {{ l("原料") }}
              </div>
              <div class="tip">{{ l("正品现货") }}、{{ l("二级余料") }}、{{ l("正品余料") }}</div>
            </div>
          </div>
        </div>

        <div class="divider"></div>

        <div class="lineContainer service">
          <div class="title">
            <el-image :src="GetResourceUrl('header/icon-post.svg')" style="
                width: 15px;
                height: 15px;
                vertical-align: text-top;
                margin-right: 2px;
              "></el-image>
            {{l("更多类型，来论坛发帖互动吧~")}}
          </div>
          <div class="buttonList">
            <div v-for="item of $store.state.basicInfo.tagList.forum" :key="item.id">
              <div class="buttonItem" @click="
                $router.push({
                  name: 'forum',
                  query: { tag_id: item.id },
                });
              showPublishDialog = false;
              ">
                {{ l(item.name) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "homeHeader",
  data() {
    let searchPathList = [
      {
        path: "/home/quotation",
        name: this.l("现货卖场"),
      },
      {
        path: "/home/purchase_forging",
        name: this.l("锻件定制"),
      },
      {
        path: "/home/purchase_material",
        name: this.l("原料求购"),
      },
      {
        path: "/home/raise",
        name: this.l("钢厂拼单"),
      },
      // {
      //   path: "/home/purchase_piece",
      //   name: this.l("零切交易"),
      // },
      {
        path: "/home/forum",
        name: this.l("周边论坛"),
      },
    ];

    return {
      isDemo: false,

      //search相关
      filterText: this.$store.state.headerFilter,
      searchPath: "",
      searchPathList,

      showPublishDialog: false,

      rect: null,
      inNav: false,
      inSub: false,
    };
  },
  watch: {
    "$route.path"() {
      this.updatesearchPath();
    },
    filterText(value) {
      this.$store.commit("updateHeaderFilter", value);
    },
  },
  created() {
    if (
      window.location.href.indexOf("local") != -1 ||
      window.location.href.indexOf("demo") != -1
    ) {
      this.isDemo = true;
    }
    this.updatesearchPath();
  },

  methods: {
    navTo(path) {
      // this.filterText = "";
      this.$store.commit("updateHeaderFilter", "");
      this.$router.push(path);
    },
    changeSearchPath() {
      this.$router.push({ path: this.searchPath });
    },
    updatesearchPath() {
      this.searchPath =
        this.searchPathList
          .map((item) => item.path)
          .find((item) => this.$route.path.indexOf(item) > -1) ||
        this.searchPathList[0].path;
    },
    querySearch(queryString, cb) {
      if (queryString) {
        cb([]);
      } else {
        var module = this.searchPath.slice(6);
        this.axios
          .get(`/api/website_config/${module}/`, { showLoading: false })
          .then((data) => {
            let arr = JSON.parse(data.value).map((item) => {
              return {
                value: item.name,
              };
            });
            cb(arr);
          });
      }
    },
    handleSelect(e) {
      this.handleSearch();
    },
    handleSearch() {
      if (this.$route.path == this.searchPath) {
        this.$EventBus.$emit("headerSearch", {
          filterText: this.filterText,
        });
      } else {
        //如nav在首页但selecttype为现货卖场
        this.$router.push({ path: this.searchPath });
      }
    },
    handleShowPublishDialog() {
      this.showPublishDialog = true;
    },
    handleCommand() {
      console.log("handleCommand");
    },
    enterNav(e, index) {
      this.inNav = true;
      let target = e.target || e.srcElement || e.toElement;
      let rect = target.getBoundingClientRect();
      this.rect = {
        left: rect.left,
        right: rect.right,
        width: rect.width,
        height: rect.height,
        index,
      };
    },
    leaveNav() {
      this.inNav = false;
      setTimeout(() => {
        if (!this.inSub) {
          this.rect = null;
        }
      });
    },
    leaveSub() {
      this.inSub = false;
      setTimeout(() => {
        if (!this.inNav) {
          this.rect = null;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.HomeContainer.i18n{
  .navItem{
    font-size:14px !important;
  }
}
.homeHeader {
  background: #fff;
}

.middle {
  height: 128px;

  .filterInput {
    width: auto;
    flex-grow: 1;

    /deep/.el-input-group__prepend {
      border-color: $primaryColor;
      background: #fff;
      border-right: 1px solid #ddd;
    }

    /deep/.el-input__inner {
      border-color: $primaryColor;
      border-left: none;
      border-right: none;
    }

    /deep/.el-input-group__append {
      border: none;
      transform: scale(1.05);
    }

    /deep/.el-input-group__prepend input {
      color: #333;
    }

    .searchBtn {
      background: $primaryColor;
      color: #fff;
    }
  }

  .publishBtn {
    margin-left: 38px;
    background: $themeColor;
    color: #fff;
  }

  .downloadContainer {
    margin-left: auto;
    text-align: center;
    font-size: 12px;
    border: 1px dashed #333;
    // padding: 5px;
    padding: 2px 2px 0;

    .el-image {
      width: 86px;
      height: 86px;
    }
  }
}

.nav {
  background: #fff;
  border-bottom: 2px solid $warningColor;
  font-size: 14px;
  line-height: 40px;
  letter-spacing: 0.5px;

  .categoryTitle {
    width: 225px;
    background: $warningColor;
    color: #fff;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding-left: 15px;

    // padding-top: 1px;
    // margin-right: 65px;
    img {
      width: 20px;
      height: 20px;
      margin-right: 12px;
    }
  }

  .navItem {
    cursor: pointer;
    font-size: 16px;
    font-weight: bold;
    color: #333;
    position: relative;

    .el-icon-arrow-down {
      margin-left: 3px;
    }

    &.active,
    &:hover {
      color: $warningColor;
    }
  }

  .memberCenter {
    background: $warningColor;
    padding: 0 20px;
    border-radius: 50px;
    color: #fff;
    height: 34px;
    line-height: 34px;
  }
}

.publishDialog {
  box-sizing: border-box;
  padding-bottom: 40px;

  .lineContainer {
    font-size: 12px;

    .title {
      // font-weight: bold;
      font-size: 14px;
    }

    .buttonList {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 25px;
      align-items: flex-start;

      >div {
        width: 200px;

        .buttonItem {
          font-size: 14px;
          width: 150px;
          height: 32px;
          line-height: 32px;
          margin-top: 20px;
          box-sizing: border-box;
          border: 1px solid $warningColor;
          color: $warningColor;
          cursor: pointer;
          letter-spacing: 1px;
          border-radius: 3px;
          text-align: center;

          &:hover {
            background: $warningColor;
            color: #fff;
          }
        }

        .tip {
          font-size: 12px;
          margin-top: 10px;
          color: #999;
          white-space: nowrap;
        }
      }
    }

    &.service .buttonList {
      >div {
        .buttonItem {
          border: 1px solid #b8c5df;
          color: #79869f;

          &:hover {
            background: #79869f;
            color: #fff;
          }
        }
      }
    }
  }

  .divider {
    height: 1px;
    background: $borderColor;
    margin-bottom: 40px;
  }
}

.subNavContainer {
  // display: none;
  position: absolute;
  width: 100%;
  min-height: 40px;
  background: #fff;
  left: 0;
  top: 198px;
  // top: 200px;
  z-index: 9;
  border-top: 1px solid $borderColor;
  box-shadow: 0 2px 4px 0 rgba(53, 53, 53, 0.1);

  flex-wrap: wrap;
  box-sizing: border-box;
  // padding: 0 30px;
  justify-content: flex-end;

  &.i18n{
    .subNavItem{
      div{
        font-size:14px !important;
      }
    }
  }

  .arrow-white {
    position: absolute;
    left: 50%;
    transform: translateX(-10px);
    bottom: 100%;
    z-index: 10;

    &:before {
      position: absolute;
      top: -15px;
      content: "";
      width: 0;
      height: 0;
      border: 7px solid transparent;
      border-bottom-color: #ddd;
    }

    &:after {
      position: absolute;
      top: -14px;
      content: "";
      width: 0;
      height: 0;
      border: 7px solid transparent;
      border-bottom-color: #fff; //填充
    }
  }

  div {
    cursor: pointer;
    font-size: 16px;
    font-weight: normal;
    color: #333;
    padding-right: 40px;
    white-space: nowrap;

    &:hover {
      color: $warningColor;
    }
  }
}

.subNavItem {
  color: #333;
  display: flex;
  line-height: 40px;

  &.right_side {
    margin-left: auto !important;
    display: flex;
    justify-content: flex-end;
    margin-right: calc(50vw - #{$HomeContainerWidth/2});

    div {
      padding-right: 0;
      padding-left: 40px;
    }
  }

  div {
    padding-right: 40px;
    white-space: nowrap;
    position: relative;
    z-index: 2;

    &:hover {
      color: $warningColor;
    }
  }
}
</style>
